import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row row-cols-2 g-5" }
const _hoisted_2 = { class: "row row-cols-2 g-5" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref } from "vue";
import TopicService from "../../services/TopicService";
import notification from "@/core/plugins/notification";
import { TenantOptions } from "@/core/types/TenantTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'updateAppInfo',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const data = ref<any>({});
const isLoading = ref(false);

const show = (appData: any) => {
  data.value = appData;
  dialogRef.value = true;
};

const updateAppInfo = async () => {
  if (!validateCheck()) return;
  isLoading.value = true;
  try {
    await TopicService.updateAppInfoById(data.value.id, data.value);
    dialogRef.value = false;
    notification.success();
  } catch (error) {
    console.error("Error updating app info:", error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const validateCheck = () => {
  if (!data.value.version || !data.value.downloadUrl) {
    notification.danger("Please fill in all fields");
    return false;
  }
  return true;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogRef).value = $event)),
    title: "Update App Info",
    width: "1000",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: updateAppInfo,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, { "label-position": "top" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, { label: "Title" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: data.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.title) = $event)),
                  placeholder: "Title",
                  disabled: isLoading.value,
                  class: "mb-4"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "version" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: data.value.version,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.version) = $event)),
                  placeholder: "App Version",
                  disabled: isLoading.value,
                  class: "mb-4"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, { label: "Tenants" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: data.value.tenants,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.tenants) = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TenantOptions), (tenant, index) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: index,
                        label: tenant.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tenant.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, { label: "download url" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: data.value.downloadUrl,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.downloadUrl) = $event)),
                placeholder: "App Download URL",
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})